import * as React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import FadeIn from "@utils/Fadein";
import urllite from 'urllite';
import IComDocType from "@components/IComDocType/IcomDocType";

export default class IcomBlock extends React.Component {
    // model props
    constructor(props) {
        super(props);
        this.navigate = this.navigate.bind(this);
        this.onResize = this.onResize.bind(this);
        this.state = { scale: 1, widthRatio: 1 }
        this.imageContainer = React.createRef()
    }


    navigate(e) {
        // Server?
        const serverRender = typeof window === 'undefined';
        const { navigation } = this.props;


        // Ignore canceled events, modified clicks, and right clicks.
        if (e.defaultPrevented) {
            return;
        }

        if (e.metaKey || e.ctrlKey || e.shiftKey) {
            return;
        }

        if (e.button !== 0) {
            return;
        }

        // Get the <a> element.
        var el = e.target;
        while (el && el.nodeName !== 'A') {
            el = el.parentNode;
        }

        // Ignore clicks from non-a elements.
        if (!el) {
            return;
        }

        // Ignore the click if the element has a target.
        if (el.target && el.target !== '_self') {
            return;
        }

        // Ignore the click if it's a download link. (We use this method of
        // detecting the presence of the attribute for old IE versions.)
        if (el.attributes.download) {
            return;
        }


        //console.debug("NAVIGATE!:", el);
        // Ignore hash (used often instead of javascript:void(0) in strict CSP envs)
        const href = el.getAttribute('href');
        if (href && href.length > 0 && href[0] === '#') { // && !(this.props.environment instanceof HashEnvironment)) {
            return;
        }


        var url = urllite(el.href);
        var windowURL = urllite(window.location.href);

        // Ignore links that don't share a protocol and host with ours.
        if (url.protocol !== windowURL.protocol || url.host !== windowURL.host) {
            return;
        }

        // Ignore 'rel="external"' links.
        if (el.rel && /(?:^|\s+)external(?:\s+|$)/.test(el.rel)) {
            return;
        }

        // Prevent :focus from sticking; preventDefault() stops blur in some browsers
        el.blur();
        e.preventDefault();

        //history.push(url);
        navigation.navigateToSiteUrl(null, url.pathname, null, null, url.search);
    }

    hexToRgbA(hex) {
        var c;
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            c = hex.substring(1).split('');
            if (c.length === 3) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c = '0x' + c.join('');
            return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',0.2)';
        }
        return "";
        //throw new Error('Bad Hex');
    }
    getCropByAlias(model, alias) {
        if (!model.value || !model.value.crops) {
            return null;
        }
        var crop = model.value.crops.find(
            function (item) {
                return item.alias === alias;
            });

        return crop;
    }

    onResize(w, h) {
        const { model, isMobile } = this.props;
        const activeDesktopCrop = this.getCropByAlias(model, model.value.activedesktopcrop ? model.value.activedesktopcrop.alias : "");
        const activeMobileCrop =
            this.getCropByAlias(model, model.value.activemobilecrop ? model.value.activemobilecrop.alias : "");

        const crop = isMobile && activeMobileCrop
            ? activeMobileCrop
            : !activeDesktopCrop && activeMobileCrop
                ? activeMobileCrop
                : activeDesktopCrop;

        //console.debug("onResize", w);
        // retina enabled

        //this.setState({scale: (w / 1440), widthRatio: (w / crop.width) });
        this.setState({ scale: (w / 1440) });

    }

    render() {
        const { model, isMobile, maxHeight, paddingTop } = this.props;
        // Server?
        const serverRender = typeof window === 'undefined';

        if (!model.value) return (null); // Early out..

        const url = model.value.src;
        const editorName = model.editor.name; // Box, Hero, Product
        const navigation = this.props.store.navigation;

        //console.debug("model value", model.value);
        // 1. filter crop
        // Get active desktop and mobile crop
        let activeDesktopCrop = this.getCropByAlias(model, model.value.activedesktopcrop ? model.value.activedesktopcrop.alias : "");
        let activeMobileCrop =
            this.getCropByAlias(model, model.value.activemobilecrop ? model.value.activemobilecrop.alias : "");

        //console.debug("active crops", activeDesktopCrop, activeMobileCrop);

        let hideDesktop = model.value.hideOnDesktop;
        let hideMobile = model.value.hideOnMobile;
        // use old or hide current device crop
        if ((!activeDesktopCrop && !activeMobileCrop) ||
            (hideMobile && isMobile) ||
            (hideDesktop && !isMobile)
        ) {
            return (null);
        }

        // 2. use mobile breakpoints
        let crop = isMobile && activeMobileCrop
            ? activeMobileCrop
            : !activeDesktopCrop && activeMobileCrop
                ? activeMobileCrop
                : activeDesktopCrop;

        const cropAlias = crop.alias;
        let cropUrl = "?mode=crop&cropmode=percentage";


        if (crop) {
            if (crop.coordinates) {
                cropUrl += "&crop=" +
                    crop.coordinates.x1 +
                    "," +
                    crop.coordinates.y1 +
                    "," +
                    crop.coordinates.x2 +
                    "," +
                    crop.coordinates.y2;
            }
            if (crop.width) {
                cropUrl += "&width=" + crop.width;
            }

            if (crop.height) {
                cropUrl += "&height=" + crop.height;
            }
            //if (crop.coordinates) {
            //    cropUrl += "&crop=" +
            //        parseInt(crop.coordinates.x1) +
            //        "," +
            //        parseInt(crop.coordinates.y1) +
            //        "," +
            //        parseInt(crop.coordinates.x2) +
            //        "," +
            //        parseInt(crop.coordinates.y2);
            //}
            //if (crop.width) {
            //    cropUrl += "&width=" + parseInt(crop.width);
            //}

            //if (crop.height) {
            //    cropUrl += "&height=" + parseInt(crop.height);
            //}


            //todo: Add PostProcessing to remove meta-data
            cropUrl += "&format=jpg";// + navigation.ImageFormat;
            cropUrl += "&quality=60";

        }


        //const widthRatio = (crop.height / crop.width) * 100;
        //let paddingTopWidthRatio = widthRatio;

        const ratio = crop.height / crop.width;
        //const width = this.imageContainer.current.offsetWidth || crop.width;
        const width = crop.width;
        const height = width * ratio;
        
        const items = model.value.items ? model.value.items.filter(x => x.cropAlias.indexOf(cropAlias.indexOf("Mobile") > -1 ? "Mobile" : "Desktop") > -1) : [];
        let firstLink = null;
        return (
            <FadeIn
                ssr={true || navigation.ServerRender}
                duration={300}
            >
                {onload => (
                    <div ref={this.imageContainer}

                        onClick={(e) => this.navigate(e)}

                        style={{
                            position: "relative",
                            //paddingTop: height + "px", // if an external paddingTop was provided... use it
                            //paddingTop: paddingTop ? paddingTop + "%" : paddingTopWidthRatio + "%", // if an external paddingTop was provided... use it
                            //backgroundImage: "url(" + url + cropUrl + ")",
                            // backgroundRepeat: "no-repeat",
                            // backgroundPosition: "top left",
                            // backgroundSize: "contain"

                        }}
                        className={editorName}

                    >
                        <img src={url + cropUrl} style={{ display: "block" }} onLoad={onload} width={width} height={height} />

                        {/*
                         * <ReactResizeDetector handleWidth onResize={this.onResize} />
                        <img
                            onLoad={onload}
                            style={{
                                position: "absolute",
                                top: 0,
                                bottom: 0,
                                left: 0,
                                right: 0,
                                width: maxHeight ? "auto" : "100%",
                                maxHeight: maxHeight ? maxHeight : "auto"

                            }}
                            src={url + cropUrl} alt={model.value.caption} />
                            */}

                        {items.map((item, index) => {
                            //!serverRender && console.debug("item", item);

                            let itemHeight = 0;
                            if (!isNaN(parseFloat(item.heightPercent))) {
                                itemHeight = parseFloat(item.heightPercent);
                            }

                            let itemWidth = 0;
                            if (!isNaN(parseFloat(item.widthPercent))) {
                                itemWidth = parseFloat(item.widthPercent);
                            }

                            let currentValue = item.value;

                            // if array value (not a string), get current culture value
                            if (!(typeof item.value === 'string' || item.value instanceof String) && (item.value.dtgeContentTypeAlias == null)) {

                                if (!item.value) {
                                    return (null);
                                }

                                if (Array.isArray(item.value)) {
                                    const currentCultureValue =
                                        item.value.find(item => item.culture === this.props.store.navigation.CultureCode);

                                    if (currentCultureValue && currentCultureValue.value && currentCultureValue.value.length > 0) {
                                        currentValue = currentCultureValue.value;
                                    } else if (item.value.length > 0) {
                                        currentValue = item.value[0].value;
                                    } else {
                                        return (null);
                                    }
                                }

                            } else if (item.value.dtgeContentTypeAlias != null) {
                                return (<div
                                    key={index}
                                    style={{

                                        position: "absolute",

                                        left: item.xPercent <= (100 - (item.xPercent + itemWidth)) ? "" + item.xPercent + "%" : "auto",
                                        right: item.xPercent > (100 - (item.xPercent + itemWidth)) ? "calc(100% - " + (item.xPercent + itemWidth) + "%)" : "auto",
                                        bottom: (item.yPercent + itemHeight) >= 85 ? "calc(100% - " + (item.yPercent + itemHeight) + "%)" : "auto",
                                        top: (item.yPercent + itemHeight) < 85 ? "" + item.yPercent + "%" : "auto",
                                        width: "calc(" + item.widthPercent + "% - 16px)",
                                        maxWidth: `100%`,
                                        paddingLeft: 1,
                                        paddingRight: 1,
                                        minHeight: (item.yPercent + itemHeight) < 85 ? item.heightPercent + "%" : "auto", // only if its positioned in the upper part of the screen
                                        backgroundColor: this.hexToRgbA(item.background)

                                    }}
                                    className={"block-area" + (item.value.value && item.value.value.useThumbnailRatio && item.value.value.useThumbnailRatio === "1" ? " icom-doc-type" : "")} >
                                    <IComDocType {...this.props} model={item} />
                                </div>);
                            }


                            // pull first a-tag
                            const aTagRegex = /href="([^\'\"]+)/im;
                            const aTagResult = aTagRegex.exec(currentValue);
                            if (!firstLink && aTagResult) {
                                firstLink = aTagResult["1"];
                            }

                            return (<div
                                key={index}
                                style={{

                                    position: "absolute",

                                    left: item.xPercent <= (100 - (item.xPercent + itemWidth)) ? "" + item.xPercent + "%" : "auto",
                                    right: item.xPercent > (100 - (item.xPercent + itemWidth)) ? "calc(100% - " + (item.xPercent + itemWidth) + "%)" : "auto",
                                    //bottom: item.yPercent > (100 - (item.yPercent + itemHeight)) ? "calc(100% - " + (item.yPercent + itemHeight) + "%)" : "auto",
                                    //top: item.yPercent <= (100 - (item.yPercent + itemHeight)) ? "" + item.yPercent + "%" : "auto",
                                    bottom: (item.yPercent + itemHeight) >= 85 ? "calc(100% - " + (item.yPercent + itemHeight) + "%)" : "auto",
                                    top: (item.yPercent + itemHeight) < 85 ? "" + item.yPercent + "%" : "auto",
                                    width: "calc(" + item.widthPercent + "% - 16px)",
                                    maxWidth: `100%`,
                                    //paddingBottom: 10,
                                    paddingLeft: 1,
                                    paddingRight: 1,
                                    //margin: 8,
                                    minHeight: (item.yPercent + itemHeight) < 85 ? item.heightPercent + "%" : "auto", // only if its positioned in the upper part of the screen
                                    backgroundColor: this.hexToRgbA(item.background)
                                    //transform: `scale(${this.state.scale < 0.8 ? 0.8:this.state.scale})`

                                }}
                                className="block-area"
                                dangerouslySetInnerHTML={{ __html: currentValue }}
                            >

                            </div>);
                        })}

                        {firstLink && <a href={firstLink} className="block-area-link"></a>}
                    </div>)}
            </FadeIn>


        );
    }
}
